import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Badge } from '../models/badge';
import { BadgeResponse } from './models/badge-response';
import {
  ServiceCallOptions,
  useCallOptions,
} from './models/service-call-options';

@Injectable({
  providedIn: 'root',
})
export class BadgesService {
  constructor(private http: HttpClient) {}

  getBadge(badgeId: string, options?: ServiceCallOptions): Observable<Badge> {
    return this.http
      .get<BadgeResponse>(
        `${environment.apiBaseUrl}/badges/${badgeId}`,
        useCallOptions(options)
      )
      .pipe(
        map((response) => ({
          ...response,
          id: String(response.id),
          categoryId: String(response.categoryId),
        }))
      );
  }

  getBadges(options?: ServiceCallOptions): Observable<Badge[]> {
    return this.http
      .get<BadgeResponse[]>(
        `${environment.apiBaseUrl}/badges`,
        useCallOptions(options)
      )
      .pipe(
        map((response) =>
          response.map((badge) => ({
            ...badge,
            id: String(badge.id),
            categoryId: String(badge.categoryId),
          }))
        )
      );
  }

  upsertBadge(
    categoryId: string,
    badge: Badge,
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/badges`,
      { categoryId, badge },
      useCallOptions(options)
    );
  }

  deleteBadge(badgeId: string, options?: ServiceCallOptions): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiBaseUrl}/badges/${badgeId}`,
      useCallOptions(options)
    );
  }

  assignBadges(
    userId: string,
    badgesIds: string[],
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/badges/assign?userId=${userId}`,
      { badgesIds },
      useCallOptions(options)
    );
  }

  claimBadge(
    badgeId: string,
    walletAddress: string,
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/badges/${badgeId}/claim`,
      { walletAddress },
      useCallOptions(options)
    );
  }
}
